import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { YearProvider } from "@/contexts/YearContext";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import PendingApproval from "./pages/PendingApproval";
import AddStudent from "./pages/students/AddStudent";
import StudentList from "./pages/students/StudentList";
import StudentDetails from "./pages/students/StudentDetails";

import AddSubject from "./pages/subjects/AddSubject";
import AddBatch from "./pages/batches/AddBatch";
import StudentAttendance from "./pages/attendance/StudentAttendance";
import InstructorAttendance from "./pages/attendance/InstructorAttendance";
import AttendanceCalendar from "./pages/attendance/AttendanceCalendar";
import AttendanceDetails from "./pages/attendance/AttendanceDetails";
import MasterSummary from "./pages/summary/MasterSummary";
import BulkEmail from "./pages/BulkEmail";
import ManageAccounts from "./pages/ManageAccounts";
import FlightSlots from "./pages/FlightSlots";
import ViewSlots from "./pages/ViewSlots";
import AdminLogs from "./pages/AdminLogs";
import BranchManagement from "./pages/BranchManagement";
import Reports from "./pages/Reports";
import NotificationCenter from "./pages/NotificationCenter";
import SubjectClasses from "./pages/SubjectClasses";
import SubjectClassDetails from "./pages/SubjectClassDetails";
import NotFound from "./pages/NotFound";
import PageTransition from "./components/PageTransition";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
  <QueryClientProvider client={queryClient}>
    <YearProvider>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/pending-approval" element={<PendingApproval />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/students" element={<StudentList />} />
            <Route path="/students/add" element={<AddStudent />} />
            <Route path="/students/:id" element={<StudentDetails />} />
            
            <Route path="/subjects/add" element={<AddSubject />} />
            <Route path="/batches/add" element={<AddBatch />} />
            <Route path="/attendance/student" element={<StudentAttendance />} />
            <Route path="/attendance/instructor" element={<InstructorAttendance />} />
            <Route path="/attendance/calendar" element={<AttendanceCalendar />} />
            <Route path="/attendance/details" element={<AttendanceDetails />} />
            <Route path="/summary" element={<MasterSummary />} />
            <Route path="/bulk-email" element={<BulkEmail />} />
            <Route path="/manage-accounts" element={<ManageAccounts />} />
            <Route path="/flight-slots" element={<FlightSlots />} />
            <Route path="/view-slots" element={<ViewSlots />} />
            <Route path="/admin-logs" element={<AdminLogs />} />
            <Route path="/branch-management" element={<BranchManagement />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/notifications" element={<NotificationCenter />} />
            <Route path="/subject-classes" element={<SubjectClasses />} />
            <Route path="/subject-classes/:id" element={<SubjectClassDetails />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
      </BrowserRouter>
    </TooltipProvider>
    </YearProvider>
  </QueryClientProvider>
  </ThemeProvider>
);

export default App;
